import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { IDeclarationsForUpdateData } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
  declarationsForUpdate: IDeclarationsForUpdateData[];
}

export const useBulkUpdateBatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, declarationsForUpdate }: HookProps) => {
      await request({
        path: `batches/${batchId}/bulk-update`,
        method: 'POST',
        authenticate: true,
        dataObject: { declarationsForUpdate },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success(`The batch was updated, it's in the processing queue now!`);
    },
    onError: (error) => {
      showErrorToast(error, 'Error updating the batch!');
    },
  });
};
